import styled from 'styled-components';
import BgImage from 'common/src/assets/image/saasModern/map.png';
import BgImageFizzGray from 'common/src/assets/image/saasModern/map_bg_texture_fizz_gray.png';
import BgImageFizz from 'common/src/assets/image/saasModern/map_bg_texture_fizz.png';

const PartnerSectionWrapper = styled.section`
  /* padding: 120px 0; */
  padding: 90px 0px 100px 0px;
  margin-top: 230px;
  /* background-color: #f6fbf9; */
  background-image: url(${BgImage});
  background-repeat: no-repeat;
  background-position: 25% center;

  /* @media (max-width: 990px) {
    padding: 100px 0;
  }
  @media (max-width: 767px) {
    padding: 80px 0;
  }
  @media (max-width: 575px) {
    padding: 60px 0;
  } */

  @media (max-width: 1219px) {
    /* background-color: red; */
    padding: 280px 0px 100px 0px;
  }

  @media (max-width: 990px) {
      /* background-color: beige; */
      padding: 0px 0px 100px 0px;
      margin-top: -50px;
  }
  @media (max-width: 767px) {
      margin-top: -20px;
      /* background-color: green; */
  }
  @media (max-width: 575px) {
      /* background-color: yellow; */
  }


`;

export default PartnerSectionWrapper;
